import { render, staticRenderFns } from "./Customer-manage.vue?vue&type=template&id=13c6ac5e&"
import script from "./Customer-manage.vue?vue&type=script&lang=js&"
export * from "./Customer-manage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports